import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";

import Banner from "../banner/banner";
import Page from "../page/page";
import ReactGA from "react-ga4";

import "./BookingPage.scss";
import classNames from "classnames";
import { useMediaQuery } from "@react-hook/media-query";

const BookingPage = () => {
  const [searchParams] = useSearchParams();
  const cityParam = searchParams.get("city");
  const [allEvents, setAllEvents] = useState([]);
  const [allEventsForSelectedCity, setAllEventsForSelectedCity] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [remainingSpots, setRemainingSpots] = useState<number | null>(null);
  const [statDocName, setStatDocName] = useState<string | null>(null);
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Booking Page",
    });
    fetch(
      `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/events`,
    )
      .then((res) => {
        res.json().then((events) => {
          // console.log(events);
          setAllEvents(events.documents);
          setAllCities(
            events.documents
              .map((event) => event.fields.city.stringValue)
              .filter((city, index, array) => array.indexOf(city) === index),
          );
          if (cityParam) {
            setBookingLocation(cityParam);
            setAllEventsForSelectedCity(
              events.documents.filter(
                (ev) => ev.fields.city.stringValue === cityParam,
              ),
            );
          }
        });
      })
      .catch(() => {});

    if (cityParam) {
      fetch(
        `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/statistics`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.documents) {
            const statDoc = data.documents.find(
              (doc) =>
                (doc.fields?.city?.stringValue as string).toLowerCase() ===
                (cityParam as string).toLowerCase(),
            );
            if (statDoc) {
              const spots =
                statDoc.fields?.remaining_seats?.integerValue ??
                statDoc.fields?.remaining_seats?.doubleValue ??
                null;
              setRemainingSpots(spots !== null ? Number(spots) : null);
              setStatDocName(statDoc.name);
            }
          }
        })
        .catch(() => {});
    }
    //   fetch(
    //     `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/bookings`,
    //   )
    //     .then((res) => {
    //       res.json().then((bookings) => {
    //         console.log(bookings);
    //       });
    //     })
    //     .catch(() => {});
    //@ts-ignore
    // window.EBWidgets.createWidget({
    //   widgetType: "checkout",
    //   eventId: "1218801972509",
    //   modal: true,
    //   modalTriggerElementId: "eventbrite-widget-modal-trigger-1218801972509",
    //   onOrderComplete: orderCallback,
    // });
    //@ts-ignore
    // window.EBWidgets.createWidget({
    //   widgetType: "checkout",
    //   eventId: "1242104009529",
    //   modal: true,
    //   modalTriggerElementId: "eventbrite-widget-modal-trigger-1242104009529",
    //   onOrderComplete: orderCallback,
    // });
  }, [cityParam]);
  const [bookingType, setBookingType] = useState("");
  const [bookingLocation, setBookingLocation] = useState("");
  // const [modalSoloInitialized, setModalSoloInitialized] = useState(false);
  // const [modalGroupInitialized, setModalGroupInitialized] = useState(false);
  const [bookingComplete, setBookingComplete] = useState(false);
  const [intializedWidgets, setInitializedWidgets] = useState([0]);
  const isPortrait = useMediaQuery("only screen and (orientation: portrait)");

  const handleBookingTypeSelection = (type) => {
    setBookingType(type);
    if (type === "group") {
      setBookingLocation("");
    }
    // if (type === "solo" && !modalSoloInitialized) {
    //   // setModalSoloInitialized(true);
    //   setTimeout(() => {
    //     //  @ts-ignore
    //     window.EBWidgets.createWidget({
    //       widgetType: "checkout",
    //       eventId: "1218801972509",
    //       modal: true,
    //       modalTriggerElementId:
    //         "eventbrite-widget-modal-trigger-1218801972509",
    //       onOrderComplete: orderCallback,
    //     });
    //   }, 100);
    // }
    // // if (type === "group" && !modalGroupInitialized) {
    // //   setModalGroupInitialized(true);
    // // }
  };
  const handleBookingLocationSelection = (e) => {
    setBookingLocation(e.target.value);
    setAllEventsForSelectedCity(
      //@ts-ignore
      allEvents.filter((ev) => ev.fields.city.stringValue === e.target.value),
    );

    allEvents
      //@ts-ignore
      .filter((ev) => ev.fields.city.stringValue === e.target.value)
      .map((ev) => {
        //@ts-ignore
        const eventbriteId = ev.fields.eventbrite_id?.integerValue;
        //@ts-ignore
        if (eventbriteId && !intializedWidgets.includes(eventbriteId)) {
          setInitializedWidgets([...intializedWidgets, eventbriteId]);
          setTimeout(() => {
            //  @ts-ignore
            window.EBWidgets.createWidget({
              widgetType: "checkout",
              eventId: eventbriteId,
              modal: true,
              modalTriggerElementId:
                "eventbrite-widget-modal-trigger-" + eventbriteId,
              onOrderComplete: orderCallback,
            });
          }, 100);
        }
      });
  };

  const orderCallback = function () {
    console.log("Order complete!");
    setBookingComplete(true);
  };

  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [formSuccess, setFormSuccess] = useState(false);
  const [formError, setFormError] = useState("");

  const handleInscription = async (e) => {
    e.preventDefault();
    if (!nom || !prenom) {
      setFormError("Nom et prénom sont obligatoires.");
      ReactGA.event("failed_subscription_1", {
        page: window.location.pathname,
        button_name: "Subscription button",
      });
      return;
    }
    if (!email && !telephone) {
      setFormError("Veuillez renseigner un email ou un numéro de téléphone.");
      ReactGA.event("failed_subscription_2", {
        page: window.location.pathname,
        button_name: "Subscription button",
      });
      return;
    }
    setFormError("");
    try {
      ReactGA.event("successful_subscription", {
        page: window.location.pathname,
        button_name: "Subscription button",
      });
      await fetch(
        `https://firestore.googleapis.com/v1/projects/shotam-b276d/databases/(default)/documents/inscriptions`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fields: {
              nom: { stringValue: nom },
              prenom: { stringValue: prenom },
              email: { stringValue: email },
              telephone: { stringValue: telephone },
              ville: { stringValue: cityParam || "" },
              createdAt: { timestampValue: new Date().toISOString() },
            },
          }),
        },
      );

      // Decrement remaining_seats in the statistics document
      if (statDocName && remainingSpots !== null && remainingSpots > 0) {
        const newCount = remainingSpots - 1;
        await fetch(
          `https://firestore.googleapis.com/v1/${statDocName}?updateMask.fieldPaths=remaining_seats`,
          {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              fields: {
                remaining_seats: { integerValue: newCount },
              },
            }),
          },
        );
        setRemainingSpots(newCount);
      }

      setFormSuccess(true);
    } catch {
      ReactGA.event("uncaught_subscription_error", {
        page: window.location.pathname,
        button_name: "Subscription button",
      });
      setFormError("Une erreur est survenue, veuillez réessayer.");
    }
  };
  return (
    <>
      <Page className="bookingPage">
        <Banner texts={[`Game on !`]} style={{ marginTop: "100px" }} />

        {allEventsForSelectedCity.length > 0 ? (
          <div className="bookingResultContainer">
            {allEventsForSelectedCity
              //@ts-ignore
              .sort((e1, e2) => {
                //@ts-ignore
                return (
                  //@ts-ignore
                  e1.fields.date_start.timestampValue <
                    //@ts-ignore
                    e2.fields.date_end.timestampValue
                    ? -1
                    : 1
                );
              })
              .map((event) => getBookingLayout(event))}
          </div>
        ) : (
          <div className="bookingResult">
            <div className="explanationHint">Pas de résultat à afficher.</div>
          </div>
        )}

        <div className="bookingExplanation">
          <div
            className=""
            style={{
              marginBottom: 12,
              textAlign: "center",
            }}
          >
            Inscris-toi pour recevoir ton billet d'entrée !
          </div>
          <div
            className=""
            style={{ marginBottom: 32, textAlign: "center", color: "grey" }}
          >
            {/* {remainingSpots !== null ? (
              <i>
                <div className="seats">{remainingSpots}</div> place
                {remainingSpots > 1 ? "s" : ""} restante
                {remainingSpots > 1 ? "s" : ""}.
              </i>
            ) : ( */}
            <i>Inscriptions limitées aux 200 premiers participants.</i>
            {/* )} */}
          </div>
          {formSuccess ? (
            <div className="explanationHint">
              Inscription envoyée ! On te recontacte bientôt.
            </div>
          ) : (
            <form
              onSubmit={handleInscription}
              style={{ display: "flex", flexDirection: "column", gap: 12 }}
            >
              <input
                className="inscriptionInput"
                placeholder="Prénom *"
                value={prenom}
                onChange={(e) => setPrenom(e.target.value)}
              />
              <input
                className="inscriptionInput"
                placeholder="Nom *"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
              />
              <input
                className="inscriptionInput"
                placeholder="Email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                className="inscriptionInput"
                placeholder="Téléphone"
                type="tel"
                value={telephone}
                onChange={(e) => setTelephone(e.target.value)}
              />
              {formError && <div style={{ color: "red" }}>{formError}</div>}
              <button type="submit" className="showBookingButton">
                S'inscrire
              </button>
            </form>
          )}
        </div>

        <div className="videoWrapper" style={{ marginTop: "50px" }}>
          {isPortrait ? (
            <iframe
              width="100%"
              height="282"
              src="https://www.youtube.com/embed/fPEWi6GnPts"
              title="Shotam : Trailer"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
            ></iframe>
          ) : (
            <div className="trailerContainer">
              <iframe
                width="500"
                height="282"
                // src="https://www.youtube.com/embed/RTw6ekGqoyQ"
                src="https://www.youtube.com/embed/fPEWi6GnPts"
                title="Shotam : Trailer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              ></iframe>
            </div>
          )}
        </div>

        {/* <div className="bookingExplanation">
          <span className="explanationNumber">2</span>
          <div className="explanationHint">
            Il peut y avoir jusqu'à 12 joueurs par partie !
          </div>
          Tu peux inviter tes amis en leur partageant cette page !
          <div className="shareContainer">
            <FacebookShareButton
              url="https://shotamsekai.com"
              className="shareButton"
            >
              <FacebookIcon />
            </FacebookShareButton>
            <TwitterShareButton
              url="https://shotamsekai.com"
              className="shareButton"
            >
              <TwitterIcon />
            </TwitterShareButton>
            <LinkedinShareButton
              url="https://shotamsekai.com"
              className="shareButton"
            >
              <LinkedinIcon />
            </LinkedinShareButton>
            <WhatsappShareButton
              url="https://shotamsekai.com"
              className="shareButton"
            >
              <WhatsappIcon />
            </WhatsappShareButton>
          </div>
          <br />
        </div> */}
      </Page>
    </>
  );
};

const pad = (n: number) => String(n).padStart(2, "0");
const formatDate = (d: Date) =>
  `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;

const getBookingLayout = (event) => {
  const date = new Date(event.fields.date_start.timestampValue);
  const date_end = new Date(event.fields.date_end.timestampValue);

  return (
    <div className="bookingResult">
      <div>{event.fields.description.stringValue}</div>
      {/* {event.fields.eventbrite_id ? (
        <button
          id={`eventbrite-widget-modal-trigger-${event.fields.eventbrite_id.integerValue}`}
          type="button"
          className="showBookingButton"
        >
          Réserver ma place !
        </button>
      ) : (
        <button type="button" className="showBookingButton" disabled>
          Réserver ma place !
        </button>
      )} */}

      <div className="bookingResultDate">{formatDate(date)}</div>
      <div style={{ marginTop: 25 }} className="explanationHint">
        <li>Lieu : {event.fields.city.stringValue} </li>
      </div>
      <div className="explanationHint">
        <li>Date de début : {formatDate(date)} </li>
      </div>
      <div className="explanationHint">
        <li>Date de fin : {formatDate(date_end)} </li>
      </div>

      <div className="explanationHint">
        <li>Confort de jeu idéal pour les + 12 ans</li>
      </div>
    </div>
  );
};
export default BookingPage;
